import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup,  Validators } from '@angular/forms';
import { ActivatedRoute} from '@angular/router';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';

import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { MenuFuncionService, TenantService, TipoMovimientoService } from '../../../../src/app/shared/services';
import { DialogConfirmRequest, DialogConfirmResponse, TipoMovimiento, MenuFuncionCodes, SaveTipoMovimientoDto, TipoMovimientoEnum, LocalStorageKeys, TenantFeatureFlags} from '../../../../src/app/shared/model';

import { DialogConfirmComponent } from '../../../../src/app/shared/components/modals/dialogConfirm.component';

@Component({
  selector: 'app-tipo-movimiento-edit',
  templateUrl: './tipo-movimiento-edit.component.html',
  styleUrls: ['./tipo-movimiento-edit.component.scss']
})

export class TipoMovimientoEditComponent implements OnInit {

  formGroup: FormGroup;

  isValidating: boolean = false;
  isSearching: boolean = false;
  isSaving: boolean = false;
  isDeleting: boolean = false;
  isTipoSearching: boolean = false;

  canEdit: boolean = false;
  canDelete: boolean = false;
  canAdd: boolean = false;
  canView: boolean = false;
  canRecurrente: boolean = false;

  msgError: string = "";
  item: TipoMovimiento;
  tipoMovimientoList: TipoMovimientoEnum[];
  signoList: any[];

  tenantFeatureFlags: TenantFeatureFlags;

  isRosbaco: boolean = false;

  constructor (
    private formBuilder: FormBuilder,
    private location: Location,
    public dialog: MatDialog,
    private sharedFunctions: SharedFunctions,
    private route: ActivatedRoute,
    private menuService: MenuFuncionService,
    private tenantService: TenantService,
    private tipoMovimientoService: TipoMovimientoService
  ) {
  }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenuPadre(MenuFuncionCodes.TIPO_MOVIMIENTO).subscribe(data => {
      if (data != null && data.Success && data?.Result) {
        this.tenantService.getTenantFeatureFlagsById(this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId)).subscribe(dataTenant => {
          this.isValidating = false;
          if (dataTenant != null && dataTenant.Success) {
            this.tenantFeatureFlags = dataTenant.Result;

            this.isValidating = false;

            this.canEdit = data.Result.some(x => x == MenuFuncionCodes.TIPO_MOVIMIENTO_EDIT);
            this.canAdd = data.Result.some(x => x == MenuFuncionCodes.TIPO_MOVIMIENTO_ADD);
            this.canView = data.Result.some(x => x == MenuFuncionCodes.TIPO_MOVIMIENTO_LIST);
            this.canDelete = data.Result.some(x => x == MenuFuncionCodes.TIPO_MOVIMIENTO_DELETE);

            this.loadView();
          }
        },
        (err: HttpErrorResponse) => {
          this.isValidating = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.onCancel();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.buildForm();
    
    this.getTipos();
    this.getSignos();

    this.loadEntity();

    this.menuService.checkMenu(MenuFuncionCodes.MOVIMIENTO_RECURRENTES).subscribe(data => {
      if (data != null && data.Success && data?.Result) {
        this.canRecurrente = true;
      }
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      'Codigo': [null, Validators.required],
      'Nombre': [null, Validators.required],
      'TipoMovimientoEnum': [null, Validators.required],
      'Signo': [null, Validators.required],
      'EsRecurrente': [false, Validators.required],
      'PeriodicidadRecurrencia': [null],
      'EsDefaultGasto': [null],
      'EsDefaultPedido': [null],
      'EsDefaultContrato': [null],
      'Activo': [true, Validators.required]
    });

    if (this.tenantFeatureFlags?.HabilitarControlGastos) {
      const defaultGastoControl = this.formGroup.get('EsDefaultGasto');

      defaultGastoControl?.setValidators([Validators.required]);
      defaultGastoControl?.updateValueAndValidity();
      defaultGastoControl?.setValue(false);
    }

    if (this.tenantFeatureFlags?.HabilitarControlPedidos) {
      const defaultPedidoControl = this.formGroup.get('EsDefaultPedido');

      defaultPedidoControl?.setValidators([Validators.required]);
      defaultPedidoControl?.updateValueAndValidity();
      defaultPedidoControl?.setValue(false);
    }

    if (this.tenantFeatureFlags?.HabilitarControlContratos) {
      const defaultContratoControl = this.formGroup.get('EsDefaultContrato');

      defaultContratoControl?.setValidators([Validators.required]);
      defaultContratoControl?.updateValueAndValidity();
      defaultContratoControl?.setValue(false);
    }
  }

  getTipos() {
    this.isTipoSearching = true;
    this.tipoMovimientoService.getTipos().subscribe(data => {
      this.isTipoSearching = false;
      this.tipoMovimientoList = data?.Result;
    },
    (err: HttpErrorResponse) => {
      this.isTipoSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getSignos() {
    this.signoList = [
      { Id: 1, Nombre: "Positivo" },
      { Id: -1, Nombre: "Negativo" }
    ];
  }

  isProcessing() {
    return (this.isSearching || this.isSaving || this.isDeleting);
  }

  loadEntity() {
    this.route.params.subscribe(params => {
      if (params['id'] != null && params['id'] != '0') {
        var id = Number(params['id']);

        if (id > 0) {
            if (this.canView || this.canEdit) {
              this.isSearching = true;
              this.tipoMovimientoService.get(id).subscribe(data => {
                this.isSearching = false;
                if (data != null && data.Success) {
                  this.item = data.Result;

                  if (this.item != null && this.item.Id > 0) {
                    this.formGroup.patchValue(this.item);
                  }
                  else
                    this.msgError = "No se encontró el item seleccionado.";
                }
                else
                  this.msgError = "Ocurrió un error al intentar obtener los datos del item.";
            },
            (err: HttpErrorResponse) => {
              this.isSearching = false;
              this.sharedFunctions.handleError(err, true);
            })
          }
          else {
            this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
            this.onCancel();
          }
        }
        else
          this.msgError = "Item no válido.";
      }
      else {
        if (this.canAdd) {
          this.item = new TipoMovimiento(0, null, null, null, null, null, false, null, null, null, null, true);
          this.formGroup.patchValue(this.item);
        }
        else {
          this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
          this.onCancel();
        }
      }
    });
  }

  getErrorCodigo() {
    return this.formGroup.get('Codigo')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorNombre() {
    return this.formGroup.get('Nombre')?.hasError('required') ? 'El campo es obligatorio' :'';
  }

  getErrorSigno() {
    return this.formGroup.get('Signo')?.hasError('required') ? 'El campo es obligatorio' :'';
  }

  getErrorTipoMovimientoEnum() {
    return this.formGroup.get('TipoMovimientoEnum')?.hasError('required') ? 'El campo es obligatorio' :'';
  }

  onGuardar() {

    if (!this.formGroup.valid) {
      this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para continuar", "Error");
      return false;
    }

    var r = new SaveTipoMovimientoDto(null, null, null, null, null, null, null, null, null, true);

    r =
    {
      ...this.formGroup.value,
      ...
      {
        Id: (this.item?.Id ?? 0)
      }
    };

    this.isSaving = true;
    this.tipoMovimientoService.save(r).subscribe(data => {
      this.isSaving = false;
      if (data != null && data.Success && data.Result != null && data.Result.Id > 0) {
        this.sharedFunctions.showMessage("Se guardaron correctamente los datos!", "Operación Exitosa!");
        this.onCancel();
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isSaving = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onCancel() {
    this.location.back();
  }

  onDelete() {
    if (!this.canDelete)
      return false;

    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: new DialogConfirmRequest(null, "¿Está seguro que desea eliminar el item?", null, null)
    });

    dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
        if (result != null && result.Accepted) {
            this.isDeleting = true;
            this.tipoMovimientoService.delete(this.item.Id).subscribe(data => {
                this.isDeleting = false;
                if (data != null && data.Success && data.Result) {
                    this.sharedFunctions.showMessage("Se eliminaron correctamente los datos!", "Operación Exitosa!");
                    this.onCancel();
                }
                else
                    this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
            },
            (err: HttpErrorResponse) => {
                this.isDeleting = false;
                this.sharedFunctions.handleError(err, true);
            })
        }
    });
  }
}
